"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MusicRecorded = function MusicRecorded(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }), _react.default.createElement("path", {
    d: "M3 3.5C3.27614 3.5 3.5 3.27614 3.5 3C3.5 2.72386 3.27614 2.5 3 2.5C2.72386 2.5 2.5 2.72386 2.5 3C2.5 3.27614 2.72386 3.5 3 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 3.5C5.27614 3.5 5.5 3.27614 5.5 3C5.5 2.72386 5.27614 2.5 5 2.5C4.72386 2.5 4.5 2.72386 4.5 3C4.5 3.27614 4.72386 3.5 5 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 3.5C7.27614 3.5 7.5 3.27614 7.5 3C7.5 2.72386 7.27614 2.5 7 2.5C6.72386 2.5 6.5 2.72386 6.5 3C6.5 3.27614 6.72386 3.5 7 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 3.5C9.27614 3.5 9.5 3.27614 9.5 3C9.5 2.72386 9.27614 2.5 9 2.5C8.72386 2.5 8.5 2.72386 8.5 3C8.5 3.27614 8.72386 3.5 9 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 3.5C11.2761 3.5 11.5 3.27614 11.5 3C11.5 2.72386 11.2761 2.5 11 2.5C10.7239 2.5 10.5 2.72386 10.5 3C10.5 3.27614 10.7239 3.5 11 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 3.5C13.2761 3.5 13.5 3.27614 13.5 3C13.5 2.72386 13.2761 2.5 13 2.5C12.7239 2.5 12.5 2.72386 12.5 3C12.5 3.27614 12.7239 3.5 13 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 3.5C15.2761 3.5 15.5 3.27614 15.5 3C15.5 2.72386 15.2761 2.5 15 2.5C14.7239 2.5 14.5 2.72386 14.5 3C14.5 3.27614 14.7239 3.5 15 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 3.5C17.2761 3.5 17.5 3.27614 17.5 3C17.5 2.72386 17.2761 2.5 17 2.5C16.7239 2.5 16.5 2.72386 16.5 3C16.5 3.27614 16.7239 3.5 17 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 3.5C19.2761 3.5 19.5 3.27614 19.5 3C19.5 2.72386 19.2761 2.5 19 2.5C18.7239 2.5 18.5 2.72386 18.5 3C18.5 3.27614 18.7239 3.5 19 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 5.5C3.27614 5.5 3.5 5.27614 3.5 5C3.5 4.72386 3.27614 4.5 3 4.5C2.72386 4.5 2.5 4.72386 2.5 5C2.5 5.27614 2.72386 5.5 3 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 5.5C15.2761 5.5 15.5 5.27614 15.5 5C15.5 4.72386 15.2761 4.5 15 4.5C14.7239 4.5 14.5 4.72386 14.5 5C14.5 5.27614 14.7239 5.5 15 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 5.5C17.2761 5.5 17.5 5.27614 17.5 5C17.5 4.72386 17.2761 4.5 17 4.5C16.7239 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.7239 5.5 17 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 5.5C19.2761 5.5 19.5 5.27614 19.5 5C19.5 4.72386 19.2761 4.5 19 4.5C18.7239 4.5 18.5 4.72386 18.5 5C18.5 5.27614 18.7239 5.5 19 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 7.5C3.27614 7.5 3.5 7.27614 3.5 7C3.5 6.72386 3.27614 6.5 3 6.5C2.72386 6.5 2.5 6.72386 2.5 7C2.5 7.27614 2.72386 7.5 3 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 7.5C15.2761 7.5 15.5 7.27614 15.5 7C15.5 6.72386 15.2761 6.5 15 6.5C14.7239 6.5 14.5 6.72386 14.5 7C14.5 7.27614 14.7239 7.5 15 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 7.5C17.2761 7.5 17.5 7.27614 17.5 7C17.5 6.72386 17.2761 6.5 17 6.5C16.7239 6.5 16.5 6.72386 16.5 7C16.5 7.27614 16.7239 7.5 17 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 7.5C19.2761 7.5 19.5 7.27614 19.5 7C19.5 6.72386 19.2761 6.5 19 6.5C18.7239 6.5 18.5 6.72386 18.5 7C18.5 7.27614 18.7239 7.5 19 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 9.5C3.27614 9.5 3.5 9.27614 3.5 9C3.5 8.72386 3.27614 8.5 3 8.5C2.72386 8.5 2.5 8.72386 2.5 9C2.5 9.27614 2.72386 9.5 3 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 9.5C15.2761 9.5 15.5 9.27614 15.5 9C15.5 8.72386 15.2761 8.5 15 8.5C14.7239 8.5 14.5 8.72386 14.5 9C14.5 9.27614 14.7239 9.5 15 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 9.5C17.2761 9.5 17.5 9.27614 17.5 9C17.5 8.72386 17.2761 8.5 17 8.5C16.7239 8.5 16.5 8.72386 16.5 9C16.5 9.27614 16.7239 9.5 17 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 9.5C19.2761 9.5 19.5 9.27614 19.5 9C19.5 8.72386 19.2761 8.5 19 8.5C18.7239 8.5 18.5 8.72386 18.5 9C18.5 9.27614 18.7239 9.5 19 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 11.5C3.27614 11.5 3.5 11.2761 3.5 11C3.5 10.7239 3.27614 10.5 3 10.5C2.72386 10.5 2.5 10.7239 2.5 11C2.5 11.2761 2.72386 11.5 3 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 11.5C15.2761 11.5 15.5 11.2761 15.5 11C15.5 10.7239 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.7239 14.5 11C14.5 11.2761 14.7239 11.5 15 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 11.5C17.2761 11.5 17.5 11.2761 17.5 11C17.5 10.7239 17.2761 10.5 17 10.5C16.7239 10.5 16.5 10.7239 16.5 11C16.5 11.2761 16.7239 11.5 17 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 11.5C19.2761 11.5 19.5 11.2761 19.5 11C19.5 10.7239 19.2761 10.5 19 10.5C18.7239 10.5 18.5 10.7239 18.5 11C18.5 11.2761 18.7239 11.5 19 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 13.5C3.27614 13.5 3.5 13.2761 3.5 13C3.5 12.7239 3.27614 12.5 3 12.5C2.72386 12.5 2.5 12.7239 2.5 13C2.5 13.2761 2.72386 13.5 3 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 13.5C15.2761 13.5 15.5 13.2761 15.5 13C15.5 12.7239 15.2761 12.5 15 12.5C14.7239 12.5 14.5 12.7239 14.5 13C14.5 13.2761 14.7239 13.5 15 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 5.5C13.2761 5.5 13.5 5.27614 13.5 5C13.5 4.72386 13.2761 4.5 13 4.5C12.7239 4.5 12.5 4.72386 12.5 5C12.5 5.27614 12.7239 5.5 13 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 7.5C13.2761 7.5 13.5 7.27614 13.5 7C13.5 6.72386 13.2761 6.5 13 6.5C12.7239 6.5 12.5 6.72386 12.5 7C12.5 7.27614 12.7239 7.5 13 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 9.5C13.2761 9.5 13.5 9.27614 13.5 9C13.5 8.72386 13.2761 8.5 13 8.5C12.7239 8.5 12.5 8.72386 12.5 9C12.5 9.27614 12.7239 9.5 13 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 11.5C13.2761 11.5 13.5 11.2761 13.5 11C13.5 10.7239 13.2761 10.5 13 10.5C12.7239 10.5 12.5 10.7239 12.5 11C12.5 11.2761 12.7239 11.5 13 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 13.5C13.2761 13.5 13.5 13.2761 13.5 13C13.5 12.7239 13.2761 12.5 13 12.5C12.7239 12.5 12.5 12.7239 12.5 13C12.5 13.2761 12.7239 13.5 13 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 5.5C11.2761 5.5 11.5 5.27614 11.5 5C11.5 4.72386 11.2761 4.5 11 4.5C10.7239 4.5 10.5 4.72386 10.5 5C10.5 5.27614 10.7239 5.5 11 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 7.5C11.2761 7.5 11.5 7.27614 11.5 7C11.5 6.72386 11.2761 6.5 11 6.5C10.7239 6.5 10.5 6.72386 10.5 7C10.5 7.27614 10.7239 7.5 11 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 9.5C11.2761 9.5 11.5 9.27614 11.5 9C11.5 8.72386 11.2761 8.5 11 8.5C10.7239 8.5 10.5 8.72386 10.5 9C10.5 9.27614 10.7239 9.5 11 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 11.5C11.2761 11.5 11.5 11.2761 11.5 11C11.5 10.7239 11.2761 10.5 11 10.5C10.7239 10.5 10.5 10.7239 10.5 11C10.5 11.2761 10.7239 11.5 11 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 13.5C11.2761 13.5 11.5 13.2761 11.5 13C11.5 12.7239 11.2761 12.5 11 12.5C10.7239 12.5 10.5 12.7239 10.5 13C10.5 13.2761 10.7239 13.5 11 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 5.5C9.27614 5.5 9.5 5.27614 9.5 5C9.5 4.72386 9.27614 4.5 9 4.5C8.72386 4.5 8.5 4.72386 8.5 5C8.5 5.27614 8.72386 5.5 9 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 7.5C9.27614 7.5 9.5 7.27614 9.5 7C9.5 6.72386 9.27614 6.5 9 6.5C8.72386 6.5 8.5 6.72386 8.5 7C8.5 7.27614 8.72386 7.5 9 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 9.5C9.27614 9.5 9.5 9.27614 9.5 9C9.5 8.72386 9.27614 8.5 9 8.5C8.72386 8.5 8.5 8.72386 8.5 9C8.5 9.27614 8.72386 9.5 9 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 11.5C9.27614 11.5 9.5 11.2761 9.5 11C9.5 10.7239 9.27614 10.5 9 10.5C8.72386 10.5 8.5 10.7239 8.5 11C8.5 11.2761 8.72386 11.5 9 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 13.5C9.27614 13.5 9.5 13.2761 9.5 13C9.5 12.7239 9.27614 12.5 9 12.5C8.72386 12.5 8.5 12.7239 8.5 13C8.5 13.2761 8.72386 13.5 9 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 5.5C7.27614 5.5 7.5 5.27614 7.5 5C7.5 4.72386 7.27614 4.5 7 4.5C6.72386 4.5 6.5 4.72386 6.5 5C6.5 5.27614 6.72386 5.5 7 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 7.5C7.27614 7.5 7.5 7.27614 7.5 7C7.5 6.72386 7.27614 6.5 7 6.5C6.72386 6.5 6.5 6.72386 6.5 7C6.5 7.27614 6.72386 7.5 7 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 9.5C7.27614 9.5 7.5 9.27614 7.5 9C7.5 8.72386 7.27614 8.5 7 8.5C6.72386 8.5 6.5 8.72386 6.5 9C6.5 9.27614 6.72386 9.5 7 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 11.5C7.27614 11.5 7.5 11.2761 7.5 11C7.5 10.7239 7.27614 10.5 7 10.5C6.72386 10.5 6.5 10.7239 6.5 11C6.5 11.2761 6.72386 11.5 7 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 13.5C7.27614 13.5 7.5 13.2761 7.5 13C7.5 12.7239 7.27614 12.5 7 12.5C6.72386 12.5 6.5 12.7239 6.5 13C6.5 13.2761 6.72386 13.5 7 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 5.5C5.27614 5.5 5.5 5.27614 5.5 5C5.5 4.72386 5.27614 4.5 5 4.5C4.72386 4.5 4.5 4.72386 4.5 5C4.5 5.27614 4.72386 5.5 5 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 7.5C5.27614 7.5 5.5 7.27614 5.5 7C5.5 6.72386 5.27614 6.5 5 6.5C4.72386 6.5 4.5 6.72386 4.5 7C4.5 7.27614 4.72386 7.5 5 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 9.5C5.27614 9.5 5.5 9.27614 5.5 9C5.5 8.72386 5.27614 8.5 5 8.5C4.72386 8.5 4.5 8.72386 4.5 9C4.5 9.27614 4.72386 9.5 5 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 11.5C5.27614 11.5 5.5 11.2761 5.5 11C5.5 10.7239 5.27614 10.5 5 10.5C4.72386 10.5 4.5 10.7239 4.5 11C4.5 11.2761 4.72386 11.5 5 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 13.5C5.27614 13.5 5.5 13.2761 5.5 13C5.5 12.7239 5.27614 12.5 5 12.5C4.72386 12.5 4.5 12.7239 4.5 13C4.5 13.2761 4.72386 13.5 5 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 13.5C17.2761 13.5 17.5 13.2761 17.5 13C17.5 12.7239 17.2761 12.5 17 12.5C16.7239 12.5 16.5 12.7239 16.5 13C16.5 13.2761 16.7239 13.5 17 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 13.5C19.2761 13.5 19.5 13.2761 19.5 13C19.5 12.7239 19.2761 12.5 19 12.5C18.7239 12.5 18.5 12.7239 18.5 13C18.5 13.2761 18.7239 13.5 19 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 15.5C3.27614 15.5 3.5 15.2761 3.5 15C3.5 14.7239 3.27614 14.5 3 14.5C2.72386 14.5 2.5 14.7239 2.5 15C2.5 15.2761 2.72386 15.5 3 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 15.5C5.27614 15.5 5.5 15.2761 5.5 15C5.5 14.7239 5.27614 14.5 5 14.5C4.72386 14.5 4.5 14.7239 4.5 15C4.5 15.2761 4.72386 15.5 5 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 15.5C7.27614 15.5 7.5 15.2761 7.5 15C7.5 14.7239 7.27614 14.5 7 14.5C6.72386 14.5 6.5 14.7239 6.5 15C6.5 15.2761 6.72386 15.5 7 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 15.5C9.27614 15.5 9.5 15.2761 9.5 15C9.5 14.7239 9.27614 14.5 9 14.5C8.72386 14.5 8.5 14.7239 8.5 15C8.5 15.2761 8.72386 15.5 9 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 15.5C11.2761 15.5 11.5 15.2761 11.5 15C11.5 14.7239 11.2761 14.5 11 14.5C10.7239 14.5 10.5 14.7239 10.5 15C10.5 15.2761 10.7239 15.5 11 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 15.5C13.2761 15.5 13.5 15.2761 13.5 15C13.5 14.7239 13.2761 14.5 13 14.5C12.7239 14.5 12.5 14.7239 12.5 15C12.5 15.2761 12.7239 15.5 13 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 15.5C15.2761 15.5 15.5 15.2761 15.5 15C15.5 14.7239 15.2761 14.5 15 14.5C14.7239 14.5 14.5 14.7239 14.5 15C14.5 15.2761 14.7239 15.5 15 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 15.5C17.2761 15.5 17.5 15.2761 17.5 15C17.5 14.7239 17.2761 14.5 17 14.5C16.7239 14.5 16.5 14.7239 16.5 15C16.5 15.2761 16.7239 15.5 17 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 15.5C19.2761 15.5 19.5 15.2761 19.5 15C19.5 14.7239 19.2761 14.5 19 14.5C18.7239 14.5 18.5 14.7239 18.5 15C18.5 15.2761 18.7239 15.5 19 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 17.5C3.27614 17.5 3.5 17.2761 3.5 17C3.5 16.7239 3.27614 16.5 3 16.5C2.72386 16.5 2.5 16.7239 2.5 17C2.5 17.2761 2.72386 17.5 3 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 17.5C5.27614 17.5 5.5 17.2761 5.5 17C5.5 16.7239 5.27614 16.5 5 16.5C4.72386 16.5 4.5 16.7239 4.5 17C4.5 17.2761 4.72386 17.5 5 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 17.5C7.27614 17.5 7.5 17.2761 7.5 17C7.5 16.7239 7.27614 16.5 7 16.5C6.72386 16.5 6.5 16.7239 6.5 17C6.5 17.2761 6.72386 17.5 7 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 17.5C9.27614 17.5 9.5 17.2761 9.5 17C9.5 16.7239 9.27614 16.5 9 16.5C8.72386 16.5 8.5 16.7239 8.5 17C8.5 17.2761 8.72386 17.5 9 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 17.5C11.2761 17.5 11.5 17.2761 11.5 17C11.5 16.7239 11.2761 16.5 11 16.5C10.7239 16.5 10.5 16.7239 10.5 17C10.5 17.2761 10.7239 17.5 11 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 17.5C13.2761 17.5 13.5 17.2761 13.5 17C13.5 16.7239 13.2761 16.5 13 16.5C12.7239 16.5 12.5 16.7239 12.5 17C12.5 17.2761 12.7239 17.5 13 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 17.5C15.2761 17.5 15.5 17.2761 15.5 17C15.5 16.7239 15.2761 16.5 15 16.5C14.7239 16.5 14.5 16.7239 14.5 17C14.5 17.2761 14.7239 17.5 15 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 17.5C17.2761 17.5 17.5 17.2761 17.5 17C17.5 16.7239 17.2761 16.5 17 16.5C16.7239 16.5 16.5 16.7239 16.5 17C16.5 17.2761 16.7239 17.5 17 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 17.5C19.2761 17.5 19.5 17.2761 19.5 17C19.5 16.7239 19.2761 16.5 19 16.5C18.7239 16.5 18.5 16.7239 18.5 17C18.5 17.2761 18.7239 17.5 19 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 19.5C3.27614 19.5 3.5 19.2761 3.5 19C3.5 18.7239 3.27614 18.5 3 18.5C2.72386 18.5 2.5 18.7239 2.5 19C2.5 19.2761 2.72386 19.5 3 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 19.5C5.27614 19.5 5.5 19.2761 5.5 19C5.5 18.7239 5.27614 18.5 5 18.5C4.72386 18.5 4.5 18.7239 4.5 19C4.5 19.2761 4.72386 19.5 5 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 19.5C7.27614 19.5 7.5 19.2761 7.5 19C7.5 18.7239 7.27614 18.5 7 18.5C6.72386 18.5 6.5 18.7239 6.5 19C6.5 19.2761 6.72386 19.5 7 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 19.5C11.2761 19.5 11.5 19.2761 11.5 19C11.5 18.7239 11.2761 18.5 11 18.5C10.7239 18.5 10.5 18.7239 10.5 19C10.5 19.2761 10.7239 19.5 11 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 19.5C13.2761 19.5 13.5 19.2761 13.5 19C13.5 18.7239 13.2761 18.5 13 18.5C12.7239 18.5 12.5 18.7239 12.5 19C12.5 19.2761 12.7239 19.5 13 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 19.5C15.2761 19.5 15.5 19.2761 15.5 19C15.5 18.7239 15.2761 18.5 15 18.5C14.7239 18.5 14.5 18.7239 14.5 19C14.5 19.2761 14.7239 19.5 15 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 19.5C17.2761 19.5 17.5 19.2761 17.5 19C17.5 18.7239 17.2761 18.5 17 18.5C16.7239 18.5 16.5 18.7239 16.5 19C16.5 19.2761 16.7239 19.5 17 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 19.5C19.2761 19.5 19.5 19.2761 19.5 19C19.5 18.7239 19.2761 18.5 19 18.5C18.7239 18.5 18.5 18.7239 18.5 19C18.5 19.2761 18.7239 19.5 19 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 3.5C21.2761 3.5 21.5 3.27614 21.5 3C21.5 2.72386 21.2761 2.5 21 2.5C20.7239 2.5 20.5 2.72386 20.5 3C20.5 3.27614 20.7239 3.5 21 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 5.5C21.2761 5.5 21.5 5.27614 21.5 5C21.5 4.72386 21.2761 4.5 21 4.5C20.7239 4.5 20.5 4.72386 20.5 5C20.5 5.27614 20.7239 5.5 21 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 7.5C21.2761 7.5 21.5 7.27614 21.5 7C21.5 6.72386 21.2761 6.5 21 6.5C20.7239 6.5 20.5 6.72386 20.5 7C20.5 7.27614 20.7239 7.5 21 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 9.5C21.2761 9.5 21.5 9.27614 21.5 9C21.5 8.72386 21.2761 8.5 21 8.5C20.7239 8.5 20.5 8.72386 20.5 9C20.5 9.27614 20.7239 9.5 21 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 11.5C21.2761 11.5 21.5 11.2761 21.5 11C21.5 10.7239 21.2761 10.5 21 10.5C20.7239 10.5 20.5 10.7239 20.5 11C20.5 11.2761 20.7239 11.5 21 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 13.5C21.2761 13.5 21.5 13.2761 21.5 13C21.5 12.7239 21.2761 12.5 21 12.5C20.7239 12.5 20.5 12.7239 20.5 13C20.5 13.2761 20.7239 13.5 21 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 15.5C21.2761 15.5 21.5 15.2761 21.5 15C21.5 14.7239 21.2761 14.5 21 14.5C20.7239 14.5 20.5 14.7239 20.5 15C20.5 15.2761 20.7239 15.5 21 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 17.5C21.2761 17.5 21.5 17.2761 21.5 17C21.5 16.7239 21.2761 16.5 21 16.5C20.7239 16.5 20.5 16.7239 20.5 17C20.5 17.2761 20.7239 17.5 21 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 19.5C21.2761 19.5 21.5 19.2761 21.5 19C21.5 18.7239 21.2761 18.5 21 18.5C20.7239 18.5 20.5 18.7239 20.5 19C20.5 19.2761 20.7239 19.5 21 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 21.5C3.27614 21.5 3.5 21.2761 3.5 21C3.5 20.7239 3.27614 20.5 3 20.5C2.72386 20.5 2.5 20.7239 2.5 21C2.5 21.2761 2.72386 21.5 3 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 21.5C5.27614 21.5 5.5 21.2761 5.5 21C5.5 20.7239 5.27614 20.5 5 20.5C4.72386 20.5 4.5 20.7239 4.5 21C4.5 21.2761 4.72386 21.5 5 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 21.5C7.27614 21.5 7.5 21.2761 7.5 21C7.5 20.7239 7.27614 20.5 7 20.5C6.72386 20.5 6.5 20.7239 6.5 21C6.5 21.2761 6.72386 21.5 7 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 21.5C9.27614 21.5 9.5 21.2761 9.5 21C9.5 20.7239 9.27614 20.5 9 20.5C8.72386 20.5 8.5 20.7239 8.5 21C8.5 21.2761 8.72386 21.5 9 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 21.5C11.2761 21.5 11.5 21.2761 11.5 21C11.5 20.7239 11.2761 20.5 11 20.5C10.7239 20.5 10.5 20.7239 10.5 21C10.5 21.2761 10.7239 21.5 11 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 21.5C13.2761 21.5 13.5 21.2761 13.5 21C13.5 20.7239 13.2761 20.5 13 20.5C12.7239 20.5 12.5 20.7239 12.5 21C12.5 21.2761 12.7239 21.5 13 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 21.5C15.2761 21.5 15.5 21.2761 15.5 21C15.5 20.7239 15.2761 20.5 15 20.5C14.7239 20.5 14.5 20.7239 14.5 21C14.5 21.2761 14.7239 21.5 15 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 21.5C17.2761 21.5 17.5 21.2761 17.5 21C17.5 20.7239 17.2761 20.5 17 20.5C16.7239 20.5 16.5 20.7239 16.5 21C16.5 21.2761 16.7239 21.5 17 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 21.5C19.2761 21.5 19.5 21.2761 19.5 21C19.5 20.7239 19.2761 20.5 19 20.5C18.7239 20.5 18.5 20.7239 18.5 21C18.5 21.2761 18.7239 21.5 19 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 21.5C21.2761 21.5 21.5 21.2761 21.5 21C21.5 20.7239 21.2761 20.5 21 20.5C20.7239 20.5 20.5 20.7239 20.5 21C20.5 21.2761 20.7239 21.5 21 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 1.5C3.27614 1.5 3.5 1.27614 3.5 1C3.5 0.723858 3.27614 0.5 3 0.5C2.72386 0.5 2.5 0.723858 2.5 1C2.5 1.27614 2.72386 1.5 3 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 1.5C5.27614 1.5 5.5 1.27614 5.5 1C5.5 0.723858 5.27614 0.5 5 0.5C4.72386 0.5 4.5 0.723858 4.5 1C4.5 1.27614 4.72386 1.5 5 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 1.5C7.27614 1.5 7.5 1.27614 7.5 1C7.5 0.723858 7.27614 0.5 7 0.5C6.72386 0.5 6.5 0.723858 6.5 1C6.5 1.27614 6.72386 1.5 7 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 1.5C9.27614 1.5 9.5 1.27614 9.5 1C9.5 0.723858 9.27614 0.5 9 0.5C8.72386 0.5 8.5 0.723858 8.5 1C8.5 1.27614 8.72386 1.5 9 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 1.5C11.2761 1.5 11.5 1.27614 11.5 1C11.5 0.723858 11.2761 0.5 11 0.5C10.7239 0.5 10.5 0.723858 10.5 1C10.5 1.27614 10.7239 1.5 11 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 1.5C13.2761 1.5 13.5 1.27614 13.5 1C13.5 0.723858 13.2761 0.5 13 0.5C12.7239 0.5 12.5 0.723858 12.5 1C12.5 1.27614 12.7239 1.5 13 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 1.5C15.2761 1.5 15.5 1.27614 15.5 1C15.5 0.723858 15.2761 0.5 15 0.5C14.7239 0.5 14.5 0.723858 14.5 1C14.5 1.27614 14.7239 1.5 15 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 1.5C17.2761 1.5 17.5 1.27614 17.5 1C17.5 0.723858 17.2761 0.5 17 0.5C16.7239 0.5 16.5 0.723858 16.5 1C16.5 1.27614 16.7239 1.5 17 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 1.5C19.2761 1.5 19.5 1.27614 19.5 1C19.5 0.723858 19.2761 0.5 19 0.5C18.7239 0.5 18.5 0.723858 18.5 1C18.5 1.27614 18.7239 1.5 19 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 1.5C21.2761 1.5 21.5 1.27614 21.5 1C21.5 0.723858 21.2761 0.5 21 0.5C20.7239 0.5 20.5 0.723858 20.5 1C20.5 1.27614 20.7239 1.5 21 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M3 23.5C3.27614 23.5 3.5 23.2761 3.5 23C3.5 22.7239 3.27614 22.5 3 22.5C2.72386 22.5 2.5 22.7239 2.5 23C2.5 23.2761 2.72386 23.5 3 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M5 23.5C5.27614 23.5 5.5 23.2761 5.5 23C5.5 22.7239 5.27614 22.5 5 22.5C4.72386 22.5 4.5 22.7239 4.5 23C4.5 23.2761 4.72386 23.5 5 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M7 23.5C7.27614 23.5 7.5 23.2761 7.5 23C7.5 22.7239 7.27614 22.5 7 22.5C6.72386 22.5 6.5 22.7239 6.5 23C6.5 23.2761 6.72386 23.5 7 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M9 23.5C9.27614 23.5 9.5 23.2761 9.5 23C9.5 22.7239 9.27614 22.5 9 22.5C8.72386 22.5 8.5 22.7239 8.5 23C8.5 23.2761 8.72386 23.5 9 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M11 23.5C11.2761 23.5 11.5 23.2761 11.5 23C11.5 22.7239 11.2761 22.5 11 22.5C10.7239 22.5 10.5 22.7239 10.5 23C10.5 23.2761 10.7239 23.5 11 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M13 23.5C13.2761 23.5 13.5 23.2761 13.5 23C13.5 22.7239 13.2761 22.5 13 22.5C12.7239 22.5 12.5 22.7239 12.5 23C12.5 23.2761 12.7239 23.5 13 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M15 23.5C15.2761 23.5 15.5 23.2761 15.5 23C15.5 22.7239 15.2761 22.5 15 22.5C14.7239 22.5 14.5 22.7239 14.5 23C14.5 23.2761 14.7239 23.5 15 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M17 23.5C17.2761 23.5 17.5 23.2761 17.5 23C17.5 22.7239 17.2761 22.5 17 22.5C16.7239 22.5 16.5 22.7239 16.5 23C16.5 23.2761 16.7239 23.5 17 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19 23.5C19.2761 23.5 19.5 23.2761 19.5 23C19.5 22.7239 19.2761 22.5 19 22.5C18.7239 22.5 18.5 22.7239 18.5 23C18.5 23.2761 18.7239 23.5 19 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M21 23.5C21.2761 23.5 21.5 23.2761 21.5 23C21.5 22.7239 21.2761 22.5 21 22.5C20.7239 22.5 20.5 22.7239 20.5 23C20.5 23.2761 20.7239 23.5 21 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 3.5C23.2761 3.5 23.5 3.27614 23.5 3C23.5 2.72386 23.2761 2.5 23 2.5C22.7239 2.5 22.5 2.72386 22.5 3C22.5 3.27614 22.7239 3.5 23 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 5.5C23.2761 5.5 23.5 5.27614 23.5 5C23.5 4.72386 23.2761 4.5 23 4.5C22.7239 4.5 22.5 4.72386 22.5 5C22.5 5.27614 22.7239 5.5 23 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 7.5C23.2761 7.5 23.5 7.27614 23.5 7C23.5 6.72386 23.2761 6.5 23 6.5C22.7239 6.5 22.5 6.72386 22.5 7C22.5 7.27614 22.7239 7.5 23 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 9.5C23.2761 9.5 23.5 9.27614 23.5 9C23.5 8.72386 23.2761 8.5 23 8.5C22.7239 8.5 22.5 8.72386 22.5 9C22.5 9.27614 22.7239 9.5 23 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 11.5C23.2761 11.5 23.5 11.2761 23.5 11C23.5 10.7239 23.2761 10.5 23 10.5C22.7239 10.5 22.5 10.7239 22.5 11C22.5 11.2761 22.7239 11.5 23 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 13.5C23.2761 13.5 23.5 13.2761 23.5 13C23.5 12.7239 23.2761 12.5 23 12.5C22.7239 12.5 22.5 12.7239 22.5 13C22.5 13.2761 22.7239 13.5 23 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 15.5C23.2761 15.5 23.5 15.2761 23.5 15C23.5 14.7239 23.2761 14.5 23 14.5C22.7239 14.5 22.5 14.7239 22.5 15C22.5 15.2761 22.7239 15.5 23 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 17.5C23.2761 17.5 23.5 17.2761 23.5 17C23.5 16.7239 23.2761 16.5 23 16.5C22.7239 16.5 22.5 16.7239 22.5 17C22.5 17.2761 22.7239 17.5 23 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 19.5C23.2761 19.5 23.5 19.2761 23.5 19C23.5 18.7239 23.2761 18.5 23 18.5C22.7239 18.5 22.5 18.7239 22.5 19C22.5 19.2761 22.7239 19.5 23 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 21.5C23.2761 21.5 23.5 21.2761 23.5 21C23.5 20.7239 23.2761 20.5 23 20.5C22.7239 20.5 22.5 20.7239 22.5 21C22.5 21.2761 22.7239 21.5 23 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 3.5C1.27614 3.5 1.5 3.27614 1.5 3C1.5 2.72386 1.27614 2.5 1 2.5C0.723858 2.5 0.5 2.72386 0.5 3C0.5 3.27614 0.723858 3.5 1 3.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 5.5C1.27614 5.5 1.5 5.27614 1.5 5C1.5 4.72386 1.27614 4.5 1 4.5C0.723858 4.5 0.5 4.72386 0.5 5C0.5 5.27614 0.723858 5.5 1 5.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 7.5C1.27614 7.5 1.5 7.27614 1.5 7C1.5 6.72386 1.27614 6.5 1 6.5C0.723858 6.5 0.5 6.72386 0.5 7C0.5 7.27614 0.723858 7.5 1 7.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 9.5C1.27614 9.5 1.5 9.27614 1.5 9C1.5 8.72386 1.27614 8.5 1 8.5C0.723858 8.5 0.5 8.72386 0.5 9C0.5 9.27614 0.723858 9.5 1 9.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 11.5C1.27614 11.5 1.5 11.2761 1.5 11C1.5 10.7239 1.27614 10.5 1 10.5C0.723858 10.5 0.5 10.7239 0.5 11C0.5 11.2761 0.723858 11.5 1 11.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 13.5C1.27614 13.5 1.5 13.2761 1.5 13C1.5 12.7239 1.27614 12.5 1 12.5C0.723858 12.5 0.5 12.7239 0.5 13C0.5 13.2761 0.723858 13.5 1 13.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 15.5C1.27614 15.5 1.5 15.2761 1.5 15C1.5 14.7239 1.27614 14.5 1 14.5C0.723858 14.5 0.5 14.7239 0.5 15C0.5 15.2761 0.723858 15.5 1 15.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 17.5C1.27614 17.5 1.5 17.2761 1.5 17C1.5 16.7239 1.27614 16.5 1 16.5C0.723858 16.5 0.5 16.7239 0.5 17C0.5 17.2761 0.723858 17.5 1 17.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 19.5C1.27614 19.5 1.5 19.2761 1.5 19C1.5 18.7239 1.27614 18.5 1 18.5C0.723858 18.5 0.5 18.7239 0.5 19C0.5 19.2761 0.723858 19.5 1 19.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 21.5C1.27614 21.5 1.5 21.2761 1.5 21C1.5 20.7239 1.27614 20.5 1 20.5C0.723858 20.5 0.5 20.7239 0.5 21C0.5 21.2761 0.723858 21.5 1 21.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 1.5C1.27614 1.5 1.5 1.27614 1.5 1C1.5 0.723858 1.27614 0.5 1 0.5C0.723858 0.5 0.5 0.723858 0.5 1C0.5 1.27614 0.723858 1.5 1 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M1 23.5C1.27614 23.5 1.5 23.2761 1.5 23C1.5 22.7239 1.27614 22.5 1 22.5C0.723858 22.5 0.5 22.7239 0.5 23C0.5 23.2761 0.723858 23.5 1 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 1.5C23.2761 1.5 23.5 1.27614 23.5 1C23.5 0.723858 23.2761 0.5 23 0.5C22.7239 0.5 22.5 0.723858 22.5 1C22.5 1.27614 22.7239 1.5 23 1.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M23 23.5C23.2761 23.5 23.5 23.2761 23.5 23C23.5 22.7239 23.2761 22.5 23 22.5C22.7239 22.5 22.5 22.7239 22.5 23C22.5 23.2761 22.7239 23.5 23 23.5Z",
    fill: "#D2D2D2"
  }), _react.default.createElement("path", {
    d: "M19.4626 11.2443L21.2757 9.43109L21.2667 9.42211C21.3381 9.37718 21.397 9.31487 21.4378 9.24103C21.4786 9.16718 21.5 9.0842 21.5 8.99984V4.41373C21.8336 4.29578 22.1148 4.06369 22.2938 3.75849C22.4729 3.45328 22.5382 3.09461 22.4784 2.74586C22.4186 2.39711 22.2374 2.08074 21.9668 1.85267C21.6963 1.6246 21.3538 1.49951 21 1.49951C20.6462 1.49951 20.3037 1.6246 20.0332 1.85267C19.7626 2.08074 19.5814 2.39711 19.5216 2.74586C19.4618 3.09461 19.5271 3.45328 19.7062 3.75849C19.8852 4.06369 20.1664 4.29578 20.5 4.41373V8.79275L19.2444 10.0483C18.751 8.20427 17.5747 6.61692 15.9541 5.60819C14.3334 4.59946 12.3898 4.24486 10.5174 4.61631C8.64495 4.98776 6.98387 6.05745 5.87104 7.60844C4.7582 9.15943 4.27691 11.0756 4.52477 12.9684C4.77263 14.8611 5.73109 16.5888 7.20576 17.8009C8.68043 19.0131 10.5609 19.619 12.4659 19.4958C14.3708 19.3726 16.1576 18.5295 17.4638 17.1375C18.7701 15.7455 19.498 13.9088 19.5 11.9998C19.5 11.7458 19.4875 11.494 19.4626 11.2443ZM21 2.49984C21.0989 2.49984 21.1956 2.52916 21.2778 2.5841C21.36 2.63904 21.4241 2.71713 21.4619 2.80849C21.4998 2.89986 21.5097 3.00039 21.4904 3.09738C21.4711 3.19437 21.4235 3.28346 21.3535 3.35339C21.2836 3.42332 21.1945 3.47094 21.0975 3.49023C21.0005 3.50952 20.9 3.49962 20.8087 3.46178C20.7173 3.42393 20.6392 3.35985 20.5843 3.27762C20.5293 3.1954 20.5 3.09873 20.5 2.99984C20.5002 2.86728 20.5529 2.74019 20.6466 2.64645C20.7403 2.55272 20.8674 2.49999 21 2.49984ZM12 18.4998C8.41589 18.4998 5.5 15.5839 5.5 11.9998C5.5 8.41573 8.41589 5.49984 12 5.49984C15.2052 5.49984 17.8756 7.83186 18.4045 10.8882L15.3536 13.9391L15 13.5856L13.5858 14.9998L15 16.414L16.4142 14.9998L16.0607 14.6463L18.4962 12.2108C18.3845 15.6976 15.5135 18.4998 12 18.4998Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M12 10.5C11.7033 10.5 11.4133 10.588 11.1666 10.7528C10.92 10.9176 10.7277 11.1519 10.6142 11.426C10.5006 11.7001 10.4709 12.0017 10.5288 12.2926C10.5867 12.5836 10.7296 12.8509 10.9393 13.0607C11.1491 13.2704 11.4164 13.4133 11.7074 13.4712C11.9983 13.5291 12.2999 13.4994 12.574 13.3858C12.8481 13.2723 13.0824 13.08 13.2472 12.8334C13.412 12.5867 13.5 12.2967 13.5 12C13.4995 11.6023 13.3414 11.221 13.0602 10.9398C12.779 10.6586 12.3977 10.5005 12 10.5ZM12 12.5C11.9011 12.5 11.8044 12.4707 11.7222 12.4157C11.64 12.3608 11.5759 12.2827 11.5381 12.1913C11.5002 12.1 11.4903 11.9994 11.5096 11.9025C11.5289 11.8055 11.5765 11.7164 11.6464 11.6464C11.7164 11.5765 11.8055 11.5289 11.9025 11.5096C11.9994 11.4903 12.1 11.5002 12.1913 11.5381C12.2827 11.5759 12.3608 11.64 12.4157 11.7222C12.4707 11.8044 12.5 11.9011 12.5 12C12.4998 12.1326 12.4471 12.2596 12.3534 12.3534C12.2596 12.4471 12.1326 12.4998 12 12.5Z",
    fill: props.foregroundColor
  }));
};

MusicRecorded.defaultProps = {
  altText: "Music Recorded",
  backgroundColor: "#FFFFFF",
  foregroundColor: "#212121"
};
MusicRecorded.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = MusicRecorded;
exports.default = _default;